import styled from '@emotion/styled';

export const SlideContainer = styled.div<{ height: number }>`
  transition: height 0.4s;
  overflow: hidden;
  height: ${({ height }) => height}px;
`;
